
function App() {
  
  const onButtonClick = () => {
    let form = document.getElementById("form__submit");
    form.submit();
  };

  return (
    <form id="form__submit" method="post" action="https://Simplecheckout.authorize.net/payment/CatalogPayment.aspx"> 
      <input type="hidden" name="LinkId" value="05224caa-c8d0-4748-b3ed-976416ab35f3" /> 
      <input type="button" onClick={() => onButtonClick()}  value="PAY HERE!" /> 
    </form>
  );
}

export default App;
